import React from 'react'
import serialize from 'serialize-javascript'
// import { Layout } from 'element-react'
import Header from '../components/header'
import Footer from '../components/footer'
import AsiderBar from '../components/asiderbar'
import HomeJoin from '../components/HomeJoin';

import dataqinlogo from '../assets/image/dataqinlogo.ico'
// import AsiderBar from '../components/asider'

// 这里到时候引入自己iconfont上资源，上面的就可以去除
// import { createFromIconfontCN } from '@ant-design/icons';

// const IconFont = createFromIconfontCN({
//   scriptUrl: '//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js',
// })
// import 'antd/dist/antd.css'
import '../assets/common.less'
import './index.less'

const navList = [
  { name: '首页', link: '/' },
  { name: '保全网', link: '/baoquan' },
  { name: '数融平台', link: '/dataplatform' },
  {
    name: '技术成果',
    link: '/achievements',
    children: [
      { name: '研究院', link: '/achievements/academy' },
      { name: '氚链', link: '/achievements/hybridchain' },
    ],
  },
  {
    name: '解决方案',
    link: '/solution',
    children: [
      { name: '金融', link: '/solution/finance' },
      { name: '知识产权', link: '/solution/propertyRight' },
      { name: '教育', link: '/solution/education' },
      { name: '公益', link: '/solution/publicWelfare' },
    ],
  },
  { name: '实时资讯', link: '/news' },
  { name: '关于', link: '/about' },
]

let activeLink = 0

function goLink(link) {
  history.push(link)
  // getScrollTop(0);
}
function isActive(link) {
  link === '/' ? activeLink === link : activeLink.includes(link)
}

const commonNode = (props) => {
  const { theme = 'light', showHomeJoin = true } = props
  // 为了同时兼容ssr/csr请保留此判断，如果你的layout没有内容请使用 props.children ?  props.children  : ''
  return props.children ? (
    <div className="container">
      <Header theme={theme} />
      {props.children}
      { showHomeJoin && <HomeJoin /> }
      <Footer />
      <AsiderBar />
    </div>
  ) : (
    ''
  )
}  

const Layout = (props) => {
  if (__isBrowser__) {
    return commonNode(props)
  } else {
    const { serverData } = props.layoutData
    const { injectCss, injectScript } = props.layoutData.app.config
    return (
      <html lang="en">
        <head>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
          <meta name="theme-color" content="#000000" />
          {/* <Link /> */}
          <link rel="icon" href={dataqinlogo} type="image/x-icon" />
          <link rel="shortcut icon" href={dataqinlogo} type="image/x-icon" />
          <title>数秦科技_“区块链+大数据”数字化服务专家</title>
          {injectCss && injectCss.map((item) => <link rel="stylesheet" href={item} key={item} />)}
          {
            <script
              dangerouslySetInnerHTML={{
                __html: `var _hmt = _hmt || [];
              (function() {
                var hm = document.createElement("script");
                hm.src = "https://hm.baidu.com/hm.js?7f481ad836f106405b9c8da645095ff7";
                var s = document.getElementsByTagName("script")[0]; 
                s.parentNode.insertBefore(hm, s);
              })();`,
              }}
            ></script>
          }
        </head>
        <body theme={props.theme}>
          <div id="app" className="routerMain">
            {commonNode(props)}
          </div>
          {serverData && (
            <script
              dangerouslySetInnerHTML={{
                __html: `window.__USE_SSR__=true; window.__INITIAL_DATA__ =${serialize(
                  serverData
                )}`,
              }}
            />
          )}
          <div
            dangerouslySetInnerHTML={{
              __html: injectScript && injectScript.join(''),
            }}
          />
        </body>
      </html>
    )
  }
}

export default Layout
